import type { TRootState } from "@/reducers";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import type { IEventSessionState } from "@reducers/eventSession";
import { eventSessionCreator } from "@reducers/eventSession";

const useEventSession = () => {
  const dispatch = useDispatch();

  const updateEventSession = useCallback((eventSession: IEventSessionState[]) => {
    dispatch(eventSessionCreator.updateEventSession(eventSession.sort((a, b) => b.index - a.index)));
  }, []);

  return {
    eventSession: useSelector((state: TRootState) => state.eventSession),
    updateEventSession,
  };
};

export default useEventSession;
